/**
 * Tutorials page: client-side search and topic/difficulty filtering over the
 * server-rendered card grid, plus click-to-play YouTube embeds. The cards carry
 * their searchable text in data attributes, so this file needs no catalog data
 * and no jQuery.
 */

function initTutorialsPage() {
    const grid = document.getElementById("tutorials-grid");
    if (!grid) {
        return;
    }

    const searchInput = document.getElementById("tutorial-search");
    const topicSelect = document.getElementById("tutorial-topic");
    const difficultySelect = document.getElementById("tutorial-difficulty");
    const countLabel = document.getElementById("tutorial-count");
    const emptyState = document.getElementById("tutorials-empty");
    const items = Array.from(grid.querySelectorAll(".tutorial-item"));

    function applyFilters() {
        const query = searchInput.value.trim().toLowerCase();
        const topic = topicSelect.value;
        const difficulty = difficultySelect.value;

        let visible = 0;
        for (const item of items) {
            const haystack = `${item.dataset.title} ${item.dataset.description}`;
            const matches =
                (!query || haystack.includes(query)) &&
                // A video carries a list of topics; picking one matches any video
                // filed under it. data-topics is pipe-delimited and pipe-terminated,
                // so this cannot match a label that is a prefix of another.
                (!topic || (item.dataset.topics || "").includes(`|${topic}|`)) &&
                (!difficulty || item.dataset.difficulty === difficulty);
            item.classList.toggle("is-hidden", !matches);
            if (matches) {
                visible += 1;
            }
        }

        const noun = items.length === 1 ? "tutorial" : "tutorials";
        countLabel.textContent = `Showing ${visible} of ${items.length} ${noun}`;
        emptyState.classList.toggle("is-hidden", visible > 0);
    }

    searchInput.addEventListener("input", applyFilters);
    topicSelect.addEventListener("change", applyFilters);
    difficultySelect.addEventListener("change", applyFilters);

    for (const button of document.querySelectorAll(".tutorials-clear")) {
        button.addEventListener("click", () => {
            searchInput.value = "";
            topicSelect.value = "";
            difficultySelect.value = "";
            applyFilters();
            searchInput.focus();
        });
    }

    // Thumbnails swap to a real player only on demand, so a page full of videos
    // costs one image per card up front instead of one YouTube iframe per card.
    grid.addEventListener("click", (event) => {
        const button = event.target.closest(".tutorial-play");
        if (!button) {
            return;
        }
        const iframe = document.createElement("iframe");
        iframe.className = "tutorial-embed";
        iframe.src =
            "https://www.youtube-nocookie.com/embed/" +
            encodeURIComponent(button.dataset.youtubeId) +
            "?autoplay=1&rel=0";
        iframe.title = button.dataset.videoTitle || "Tutorial video";
        iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;
        button.replaceWith(iframe);
    });

    applyFilters();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTutorialsPage, { once: true });
} else {
    initTutorialsPage();
}
